var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSchedulingSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 131,
    viewBox: "0 0 132 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.41 130.545C77.0997 130.545 89.5043 126.782 100.055 119.732C110.606 112.682 118.83 102.662 123.686 90.9381C128.542 79.2144 129.813 66.314 127.337 53.8681C124.862 41.4223 118.751 29.9901 109.778 21.0172C100.805 12.0442 89.3728 5.93357 76.927 3.45794C64.4812 0.982315 51.5807 2.2529 39.857 7.10902C28.1333 11.9651 18.1129 20.1887 11.0629 30.7397C4.01292 41.2908 0.25 53.6955 0.25 66.3851C0.25 83.4014 7.00969 99.7208 19.042 111.753C31.0744 123.785 47.3937 130.545 64.41 130.545Z",
    fill: "#7DFFBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6499 39.6351H47.4899L65.6799 75.7751L98.5199 1.95508H130.25L80.5499 103.955H48.8199L18.6499 39.6351Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 131.5,
    height: 130.09,
    fill: "white",
    transform: "translate(0.25 0.455078)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSchedulingSuccess);
export default __webpack_public_path__ + "static/media/icon_scheduling_success.31415b74.svg";
export { ForwardRef as ReactComponent };